import japan from './worlds/japan'
import josephine from './worlds/josephine'
import diademe from './worlds/diademe'
import home from './worlds/home'
import wild from './worlds/wild'
import sovereign from './worlds/sovereign'
import sentimental from './worlds/sentimental'
import transformer from './worlds/transformer'

export default {
  japan: japan,
  josephine: josephine,
  tiara: diademe,
  maison: home,
  nature: wild,
  sovereigns: sovereign,
  sentimental: sentimental,
  transformer: transformer
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds.js